import { CONFIG } from '../../../../../config/mainConfig';
import { ICharacterOutlineByUser } from '../../../../../interfaces/book.interface';
import { StoryCharacterAgeUnitEnum, StoryCharacterEnum } from '../../../../../interfaces/character.interface';
import { IStoryData } from '../../../../../store/storySlice';

interface IUpdateCharacterOutlineParams {
  selectedImage: string;
  storyData: IStoryData;
  characterOutlineByUser: ICharacterOutlineByUser;
}

export const updateCharacterOutline = ({
                                         selectedImage,
                                         storyData,
                                         characterOutlineByUser
                                       }: IUpdateCharacterOutlineParams) => {
  const isDefaultImage = selectedImage === CONFIG.CHARACTER.DUMMY_IMAGE;
  const currentCharacter = characterOutlineByUser?.characterType || StoryCharacterEnum.human;

  const updatedCharacterOutline = {
    age: isDefaultImage ? storyData?.age || '' : currentCharacter === StoryCharacterEnum.human ? '' : storyData?.age,
    ageUnit: storyData?.ageUnit || StoryCharacterAgeUnitEnum.year,
    mics: storyData?.mics || '',
    gender: isDefaultImage || currentCharacter !== StoryCharacterEnum.human ? storyData?.gender : '',
    animalType: isDefaultImage || currentCharacter !== StoryCharacterEnum.human ? storyData?.animalType : '',
    characterType: storyData?.characterType || currentCharacter,
    character: storyData?.character || currentCharacter
  };

  return updatedCharacterOutline;
};
